module.exports = __webpack_public_path__ + "img/taiping.5906b473.png";